import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Box, CircularProgress } from '@mui/material';
import { theme } from '@/styles/theme'
import {AppRouter} from '@/routes/AppRouter'
import { useAppDispatch, useAppSelector } from '@/app/hooks';
import { initializeAuth } from '@/features/auth/authThunks';
import { selectAuthInitialized } from '@/features/auth/authSelectors';
import { getUserByDocId } from '@/features/users/usersThunks';
import { useAuth } from './hooks/useAuth';
import { roleMap } from './utils/permissions';
import { setUser } from './features/users/usersSlice';

function App() {
  const dispatch = useAppDispatch();
  const isInitialized = useAppSelector(selectAuthInitialized);
  const {authUser, currentUser} = useAuth()

  useEffect(() => {
    const initAuth = async () => {
      try {
        await dispatch(initializeAuth());
      }
      catch (error) {
        console.error('Error initializing auth:', error);
      }
    };

    initAuth();
  }, [dispatch]);

    useEffect(() => {
      const fetchUserData = async () => {
        if (authUser?.uid && authUser.role && !currentUser) {
          try {
            const role = roleMap[authUser.role.toLowerCase()];
            if (role) {
              const user = await dispatch(getUserByDocId({ docId: authUser.uid, role })).unwrap();
              console.log('user',user);
              dispatch(setUser(user))
            }
          } catch (error) {
            console.error("Error fetching user data:", error);
          }
        }
      };
  
      fetchUserData();
    }, [authUser, currentUser, dispatch]);

  if (!isInitialized) {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="100vh"
        >
          <CircularProgress />
        </Box>
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;